import React, { useState } from "react";
import { Drawer, Typography, Button } from "antd";
import { InfoCircleOutlined, CloseOutlined } from "@ant-design/icons";

export default function PageHelpDrawer({ helpContent, logoSrc }) {
  const [open, setOpen] = useState(false);

  if (!helpContent) return null;

  return (
    <>
      <Button
        type="text"
        icon={<InfoCircleOutlined />}
        onClick={() => setOpen(true)}
        className="page-help-btn"
        size="small"
      />
      <Drawer
        title={
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {logoSrc && (
              <img
                src={logoSrc}
                alt="Logo"
                style={{ height: 28, verticalAlign: "middle" }}
              />
            )}
            {helpContent.title}
          </span>
        }
        onClose={() => setOpen(false)}
        open={open}
        width={420}
        closeIcon={<CloseOutlined />}
        styles={{ body: { padding: "16px 24px" } }}
      >
        {helpContent.sections?.map((section, idx) => (
          <div key={idx} style={{ marginBottom: 20 }}>
            <Typography.Title level={5} style={{ marginBottom: 8 }}>
              {section.heading}
            </Typography.Title>
            {section.content && (
              <Typography.Paragraph
                style={{ marginBottom: section.items ? 8 : 0 }}
              >
                {section.content}
              </Typography.Paragraph>
            )}
            {section.items && (
              <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                {section.items.map((item, i) => (
                  <li key={i}>
                    <Typography.Text>{item}</Typography.Text>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </Drawer>
    </>
  );
}
